<template>
 <div class="container py-5" v-if="(products.length != 0)">
      <div v-if="loading" class="empty text-center center-text">

        <img src="/pet_shop/assets/images/ajax-loader.gif" />
        <br>

      </div>
      <div v-else>
        <div class="d-flex justify-content-between">
        <p class="mb-4 trirong title_section_products ">{{name }}</p>
         <router-link  :to="{
                      name: 'section',
                      params: {
                        storeName: $store.storeName,
                        id: id,
                        name: name,
                        lang: $i18n.locale
                      },}"
                       class="mb-4 trirong all_product">{{$t('all') }}</router-link>
                       </div>
        <div class="row row-cols-2 row-cols-md-3 row-cols-lg-6 g-4">
          <!-- Repeat this card for each product -->
          <product v-for="(item, index) in this.products" :key="index" :name="item.name" :description="item.description"
            :is_favorit="item.is_favorit" :image="item.image" :old_price="item.old_price" :new_price="item.new_price"
            :productid="item.id" :rate="item.rate" :count_view="item.count_views" :is_option="item.is_option"
            :is_offer="item.is_offer" :unit="item.unit" :new="item.is_new" :fetuered="item.is_fetured"
            :discount="item.discount" :qnt="item.qnt" :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note"
            :range_price="item.range_price"></product>
        </div>
      </div>
    </div>
</template>

<script>
import product from "../components/one_product.vue";

export default {
  components: {product},
  props: {
    name: String,
    id: Number,
    products:Array
   

  },
  data: function () {
   
    return {
      loading:false,
      langChange:'',
    new_products :[]
    };
  },
  created() {
    // this.new_products=[];
    //   this.type=this.id;

    //   this.loading = true;
     
    //   this.axios
    //   .get(
    //     this.$store.state.base_api_url + this.$store.storeName + "/theme8/products/section/"+this.type+"/category/0",
        
    //     {
    //       headers: {
    //         "Accept-Language": this.$i18n.locale,
    //         Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
    //       }
    //     }
        
    //   )
    //   .then((response) => {
    //     this.new_products = response.data.data;
    //   })
    //   .then(() => (this.loading = false));
  },
  methods: {
  
   
    updatedata()
    {
      this.new_products=[];
      this.type=this.id;

      this.loading = true;
     
      this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/theme8/products/section/"+this.type+"/category/0",
        
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
          }
        }
        
      )
      .then((response) => {
        this.new_products = response.data.data;
      })
      .then(() => (this.loading = false));
      
      this.$store.state.langchange=false;
    }
  },
  watch:{
    langChange() {
    // this.new_products=[];
    //   this.type=this.id;

    //   this.loading = true;
     
    //   this.axios
    //   .get(
    //     this.$store.state.base_api_url + this.$store.storeName + "/theme8/products/section/"+this.type+"/category/0",
        
    //     {
    //       headers: {
    //         "Accept-Language": this.$i18n.locale,
    //         Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
    //       }
    //     }
        
    //   )
    //   .then((response) => {
    //     this.new_products = response.data.data;
    //   })
    //   .then(() => (this.loading = false));
  },
 
},


}
</script>